module.exports = __webpack_public_path__ + "img/Gunnar-Ploehn-680.a6d1ec23.jpg";